import Vue from "vue";
import { Component } from "vue-property-decorator";
import { UserLimitClient } from "../backend/backendapi";
import { initClient } from "../../api";
import Toasted from "vue-toasted";

Vue.use(Toasted)

@Component({
    name: 'UserLimit',
    components: {},
})
export default class UserLimit extends Vue {
    private readonly api = initClient(UserLimitClient);

    mounted(): Promise<void> {
        return this.api.userLimitReached()
            .then(e => {
                if (e.result) {
                    this.$toasted.show("Max user size of licensed reached. New app logins not possible, get in touch with Revotec GmbH.", { duration: 60000, type: 'warning' });
                }
            });
    }
}